var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect } from "react";
import { Layout, SidebarClasses } from "react-admin";
import { CustomAppBar } from "./CustomAppBar";
import { CustomMenu } from "./CustomMenu";
import { CustomSidebar } from "./menu/CustomSidebar";
import { TenantContext } from "@/providers/TenantContextProvider";
import { useGetOne } from "react-admin";
import cssInputLookAndFeel from "@/atoms/css-input-look-and-feel";
import { useAtomValue, useSetAtom } from "jotai";
import { ImportDataDrawer } from "./election-event/import-data/ImportDataDrawer";
import { CreateElectionEventProvider, useCreateElectionEventStore, } from "@/providers/CreateElectionEventContextProvider";
import { CreateDataDrawer } from "./election-event/create/CreateElectionEventDrawer";
export var CustomCssReader = function () {
    var _a;
    var tenantId = useContext(TenantContext).tenantId;
    var tenantData = useGetOne("sequent_backend_tenant", {
        id: tenantId,
    }).data;
    var setAtomValue = useSetAtom(cssInputLookAndFeel);
    var css = useAtomValue(cssInputLookAndFeel);
    useEffect(function () {
        var _a, _b;
        var customCss = (_b = (_a = tenantData === null || tenantData === void 0 ? void 0 : tenantData.annotations) === null || _a === void 0 ? void 0 : _a.css) !== null && _b !== void 0 ? _b : "";
        if (css !== customCss) {
            setAtomValue(customCss);
        }
    }, [(_a = tenantData === null || tenantData === void 0 ? void 0 : tenantData.annotations) === null || _a === void 0 ? void 0 : _a.css, setAtomValue, css]);
    return _jsx(_Fragment, {});
};
var SequentSidebar = function (props) {
    var _a = useCreateElectionEventStore(), createDrawer = _a.createDrawer, closeCreateDrawer = _a.closeCreateDrawer;
    return (_jsxs(CreateElectionEventProvider, { children: [_jsx(CustomCssReader, {}), _jsx(CustomSidebar, __assign({}, props, { children: _jsx(CustomMenu, __assign({}, props, { classes: SidebarClasses })) })), _jsx(CreateDataDrawer, { open: createDrawer, closeDrawer: function () { return closeCreateDrawer === null || closeCreateDrawer === void 0 ? void 0 : closeCreateDrawer(); } }), _jsx(ImportDataDrawer, { title: "electionEventScreen.import.eetitle", subtitle: "electionEventScreen.import.eesubtitle", paragraph: "electionEventScreen.import.electionEventParagraph" })] }));
};
export var CustomLayout = function (props) { return (_jsx(Layout, __assign({}, props, { sx: {
        "width": "100%",
        "& .MuiPaper-root.RaSidebar-paper, & .MuiPaper-root.MuiAppBar-root": {
            top: "0",
            position: "sticky",
            zIndex: 100,
        },
        "& .MuiToolbar-root": {
            minHeight: "unset",
        },
        "& .RaList-main": {
            width: "50%",
        },
    }, appBar: CustomAppBar, 
    // sidebar={withCreateElectionEventProvider(SequentSidebar)}
    sidebar: SequentSidebar }))); };
